module.exports = __webpack_public_path__ + "img/YtLogo.d337e862.png";